// extracted by mini-css-extract-plugin
export default {"cls1":"ResultsList-Item_cls1__ArwK+","cls2":"ResultsList-Item_cls2__6EjcE ResultsList-Item_cls1__ArwK+"};